    document.addEventListener('DOMContentLoaded', function () {
      const addButton = document.querySelector('.frequently-bought-together__add-button');

      if (addButton) {
        addButton.addEventListener('click', function () {
          const currentProductId = this.dataset.currentProductId;
          const currentVariantId = this.dataset.currentVariantId;
          const complementaryProductId = this.dataset.complementaryProductId;
          const complementaryVariantId = this.dataset.complementaryVariantId;

          // Add both products to cart
          const formData = {
            items: [
              {
                id: currentVariantId,
                quantity: 1,
              },
              {
                id: complementaryVariantId,
                quantity: 1,
              },
            ],
          };

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
          })
            .then((response) => response.json())
            .then((data) => {
              // Trigger cart update events
              document.documentElement.dispatchEvent(
                new CustomEvent('cart:updated', {
                  bubbles: true,
                })
              );

              // Show success message or redirect to cart
              window.location.href = '/cart';
            })
            .catch((error) => {
              console.error('Error:', error);
            });
        });
      }
    });
    document.addEventListener('DOMContentLoaded', function () {
      const currentSelect = document.querySelector('select[name="current_product_variant"]');
      const complementarySelect = document.querySelector('select[name="complementary_product_variant"]');

      const totalPriceElement = document.querySelector('#frequently-bought-together [data-total-price]');
      const comparePriceElement = document.querySelector('#frequently-bought-together [data-compare-price]');
      const saveBadgeText = document.querySelector('#frequently-bought-together [data-save-text]');
      const saveBadgeContainer = saveBadgeText ? saveBadgeText.closest('div') : null;

      const currencySymbol = '{{ cart.currency.symbol }}';

      function formatMoney(cents) {
        if (typeof cents !== 'number') return `${currencySymbol}0.00`;
        return `${currencySymbol}${(cents / 100).toFixed(2)}`;
      }

      async function fetchVariant(variantId) {
        const response = await fetch(`/variants/${variantId}.js`);
        return response.ok ? response.json() : null;
      }

      async function updateTotalPrice() {
        const currentVariantId = currentSelect?.value || document.querySelector('.frequently-bought-together__add-button')?.dataset.currentVariantId;
        const complementaryVariantId = complementarySelect?.value || document.querySelector('.frequently-bought-together__add-button')?.dataset.complementaryVariantId;

        if (!currentVariantId || !complementaryVariantId) return;

        const [currentVariant, complementaryVariant] = await Promise.all([fetchVariant(currentVariantId), fetchVariant(complementaryVariantId)]);

        if (!currentVariant || !complementaryVariant) return;

        const totalPrice = currentVariant.price + complementaryVariant.price;
        const totalCompare = (currentVariant.compare_at_price ?? currentVariant.price) + (complementaryVariant.compare_at_price ?? complementaryVariant.price);

        if (totalPriceElement) totalPriceElement.textContent = formatMoney(totalPrice);

        if (comparePriceElement) {
          if (totalCompare > totalPrice) {
            comparePriceElement.textContent = formatMoney(totalCompare);
            comparePriceElement.style.display = 'inline';
          } else {
            comparePriceElement.style.display = 'none';
          }
        }

        if (saveBadgeText && saveBadgeContainer) {
          const savings = totalCompare - totalPrice;
          if (savings > 0) {
            const savingsPercent = Math.round((savings / totalCompare) * 100);
            saveBadgeText.textContent = `${savingsPercent}% SAVE : ${formatMoney(savings)}`;
            saveBadgeContainer.style.display = 'flex';
          } else {
            saveBadgeContainer.style.display = 'none';
          }
        }
      }

      if (currentSelect) currentSelect.addEventListener('change', updateTotalPrice);
      if (complementarySelect) complementarySelect.addEventListener('change', updateTotalPrice);
    });